/**
 * Provider-neutral React Native prop used to expose a semantic action identity
 * on the actual touch target. Concrete SDK adapters map this prop into their
 * autocapture configuration.
 */
export const NATIVE_ANALYTICS_LABEL_PROP = 'analyticsLabel' as const;
